import * as z from "zod/v4";

export const getProductsReviewsRatings = {
  name: "getProductsReviewsRatings" as const,
  input: z.array(z.string()),
  output: z.record(
    z.string(),
    z.object({ rating: z.number(), numReviews: z.number() }).nullable(),
  ),
};
